import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paginationPages'
})
export class PaginationPagesPipe implements PipeTransform {
  transform(numbers: number[], activePageNumber: number): number[] {
    if (numbers.length < 11) {
      return numbers;
    }
    const pagesToShow = numbers.filter((number: number) => {
      return number < 4 || number === activePageNumber || number + 3 > numbers[numbers.length - 1];
    });
    if (pagesToShow.length === 6) {
      return [...pagesToShow.splice(0, 3), 0, ...pagesToShow.splice(0, 3)];
    }
    if (activePageNumber === 4) {
      return [...pagesToShow.splice(0, 4), 0, ...pagesToShow.splice(0, 3)];
    }
    if (activePageNumber === numbers[numbers.length - 1] - 3) {
      return [...pagesToShow.splice(0, 3), 0, ...pagesToShow.splice(0, 4)];
    }
    return [...pagesToShow.splice(0, 3), 0, ...pagesToShow.splice(0, 1), 0, ...pagesToShow.splice(0, 3)];
  }
}
